import { render, staticRenderFns } from "./table-list.vue?vue&type=template&id=9032760c&scoped=true&"
import script from "./table-list.vue?vue&type=script&lang=js&"
export * from "./table-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9032760c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9032760c')) {
      api.createRecord('9032760c', component.options)
    } else {
      api.reload('9032760c', component.options)
    }
    module.hot.accept("./table-list.vue?vue&type=template&id=9032760c&scoped=true&", function () {
      api.rerender('9032760c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/tdc-manage/account/list/modules/table-list.vue"
export default component.exports